/* =========================================================
   Mobile navigation — behaviour that mmenu does not provide.
   ---------------------------------------------------------
   Loaded from sections/header.liquid, with `defer`.

   WHERE THE MENU IS SET UP. Nowhere in here. jQuery.mmenu is initialised on
   #nav-ab by assets/app.js.liquid, in order, right after #cart — mmenu hands
   out panel ids from a single global counter and the theme's #mm-1 lookup
   depends on that order. This file only binds handlers on top of it:
 
   1. The close button in the logo bar, which mmenu has no equivalent for in
      this layout.
   2. The whole-card tap, so a category row opens its sub panel instead of
      jumping to "#" when it has no destination of its own.
   3. The Convert location for the "Tapes by device" menu reorder test, fired
      from the hamburger (bound outside bindMenu, see below).

   1 and 2 belong to the navigation itself, not to any A/B test. This file is
   also where Convert location and goal wiring goes when a test is running on
   the menu.
   ========================================================= */

(function () {
  'use strict';

  var READY_POLL = 30; // ms
  var READY_TRIES = 200; // ~6s

  var bound = false;

  /* app.js.liquid owns the mmenu call, so this waits for it rather than racing
     it. */
  function whenMenuReady(callback) {
    var tries = 0;

    (function poll() {
      var $ = window.jQuery;

      if ($ && $.fn && $.fn.mmenu && $('#nav-ab').data('mmenu')) {
        callback($);
        return;
      }

      if (++tries > READY_TRIES) {
        console.warn('abmn-nav: mmenu never became available on #nav-ab.');
        return;
      }

      setTimeout(poll, READY_POLL);
    })();
  }

  function bindMenu($) {
    if (bound) return;
    bound = true;

    var $nav = $('#nav-ab');

    /* Close button. Driven by the mmenu API rather than by pointing the anchor at
       the page id the way mmenu's own close button does — that would couple the
       markup to the offCanvas pageSelector. stopPropagation keeps mmenu's own
       body-delegated a[href^="#"] handler from also acting on the click. */
    $nav.on('click', '.abmn-close', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var api = $nav.data('mmenu');
      if (api && typeof api.close === 'function') api.close();
    });

    /* Whole-card tap opens the sub panel when the category has no real
       destination of its own (the merchant sets those parents to href="#").
       When a category DOES have a destination, the card body navigates to it
       and only the chevron opens the sub panel — "cliqueable cuando
       corresponda" in the brief. */
    $nav.on('click', 'a.mm-listitem__text', function (event) {
      if (this.getAttribute('href') !== '#') return;

      var next = this.parentNode.querySelector('.mm-btn_next');
      if (!next) return;

      event.preventDefault();
      event.stopPropagation();

      next.click();
    });
  }

  /* Convert location for the "Tapes by device" menu reorder test. Same trigger
     as the "sept-q1-mobile-nav" test: fires once per page view, on mobile only,
     the first time the hamburger is touched, so visitors who never open the
     menu stay out of the experiment population.

     pointerdown/touchstart fire the location as early in the tap as possible,
     so Convert's reorder CSS has usually landed by the time the menu slides in.
     click is the fallback for keyboard activation.

     Native, capture phase on document, bound immediately rather than inside
     whenMenuReady: it needs no jQuery or mmenu, it must be listening before the
     visitor can reach the hamburger, and the capture phase runs ahead of the
     theme's own .icon-menu handler in app.js.liquid, which can stop the event. */
  var LOCATION_ID = '1004161449';
  var MOBILE_MQ = '(max-width: 798px)'; // the theme's own mobile breakpoint
  var triggered = false;

  function pushTrigger(event) {
    if (triggered) return;
    if (!event.target.closest || !event.target.closest('.icon-menu')) return;
    if (!window.matchMedia(MOBILE_MQ).matches) return;

    triggered = true;

    try {
      window._conv_q = window._conv_q || [];
      window._conv_q.push({
        what: 'triggerLocation',
        params: { locationId: LOCATION_ID }
      });
      console.log('trigger - tapes by device menu reorder');
    } catch (error) {
      console.warn('Convert tapes-by-device trigger failed:', error);
    }
  }

  ['pointerdown', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, pushTrigger, { capture: true, passive: true });
  });

  whenMenuReady(bindMenu);
})();
